import { FunctionComponent } from "react";
import { Body1SemiBold, Body3, Link1, Modal, RenameIcon } from "@horizontal-org/shira-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { MdMenuBook } from "react-icons/md";

interface Props {
  entityType: 'question' | 'quiz';
  isModalOpen: boolean;
  setIsModalOpen: (handle: boolean) => void;
  isPublicLibraryEnabled?: boolean;
  onAction: (action: 'template' | 'scratch' | 'import') => void
}

export const EntityCreationOptionsModal: FunctionComponent<Props> = ({
  entityType,
  isModalOpen,
  setIsModalOpen,
  isPublicLibraryEnabled,
  onAction
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      id="create-entity-modal"
      size="medium"
      isOpen={isModalOpen}
      title={t(`modals.create_entity.${entityType}.title`)}
      subtitle={t(`modals.create_entity.${entityType}.subtitle`)}
      primaryButtonText={''}
      secondaryButtonText={t('buttons.cancel')}
      onSecondaryClick={handleClose}
      onClose={handleClose}
    >
      <ModalContent>
        <Actions>
          {isPublicLibraryEnabled && (
            <CreationActionCard tabIndex={1} onClick={() => { onAction('template') }}>
              <IconWrapper>
                <MdMenuBook size={20} />
              </IconWrapper>
              <TextContent>
                <Body1SemiBold>
                  {t(`modals.create_entity.${entityType}.template_title`)}
                </Body1SemiBold>
                <Body3>
                  {t(`modals.create_entity.${entityType}.template_subtitle`)}
                </Body3>
              </TextContent>
            </CreationActionCard>
          )}
          <CreationActionCard tabIndex={2} onClick={() => { onAction('scratch') }}>
            <RenameIconWrapper>
              <RenameIcon />
            </RenameIconWrapper>
            <TextContent>
              <Body1SemiBold>
                {t(`modals.create_entity.${entityType}.scratch_title`)}
              </Body1SemiBold>
              <Body3>
                {t(`modals.create_entity.${entityType}.scratch_subtitle`)}
              </Body3>
            </TextContent>
          </CreationActionCard>
        </Actions>

        <ImportBox>
          <Link1
            onClick={() => { onAction('import') }}
          >
            {t(`modals.create_entity.${entityType}.import_title`)}
          </Link1>
        </ImportBox>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ImportBox = styled.div`
  text-align: center;
`

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const CreationActionCard = styled.div`
  cursor: pointer;
  padding: 20px;
  border: 1px solid ${props => props.theme.colors.dark.lightGrey};
  border-radius: 28px;
  display: flex;
  gap: 16px;

  &:hover {
    background: #FAFBF0;
  }

  &:focus {
    border: 3px solid ${props => props.theme.colors.green4};
  }  
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55px;
  min-width: 55px;
  height: 55px;
  min-height: 55px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.light.paleGreen};

  > svg {
    color: ${props => props.theme.colors.green7};
  }
`

const RenameIconWrapper = styled(IconWrapper)`

  >svg {
    width: 18px;
    height: 18px;
    > path {
      fill: ${props => props.theme.colors.green7};
    }
  }
`

const TextContent = styled.div`
  
`